"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPlayer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * 파일첨부형 테스트용 제한 오디오 플레이어.
 * - 구간 이동 제한: 타임바는 표시 전용(클릭/드래그 불가) + seeking 이벤트 차단(정방향 연속만)
 * - 일시정지 불가: 최초 재생 후 재생 버튼 비활성화
 * - 정방향 연속 재생만 가능
 */
const Wrap = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 14px;
	background: #f3f4f8;
	border: 1px solid #e0e3e8;
	border-radius: 10px;
	margin-bottom: 12px;
	width: 100%;
	box-sizing: border-box;

	.play-btn {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: none;
		background: #3ab2bf;
		color: #fff;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		line-height: 1;
	}
	.play-btn:disabled {
		background: #9aa0a6;
		cursor: default;
	}
	.name {
		font-size: 12px;
		color: #101010;
		max-width: 180px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		flex-shrink: 0;
	}
	.bar {
		flex: 1;
		height: 6px;
		background: #d7d9dc;
		border-radius: 3px;
		overflow: hidden;
		pointer-events: none;
	}
	.bar .fill {
		height: 100%;
		background: #3ab2bf;
		transition: width 0.2s linear;
	}
	.time {
		font-size: 12px;
		color: #666666;
		flex-shrink: 0;
		white-space: nowrap;
	}
`;
const formatTime = (s) => {
    if (!Number.isFinite(s) || s < 0)
        return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
};
const AudioPlayer = ({ src, fileName }) => {
    const audioRef = (0, react_1.useRef)(null);
    const lastTimeRef = (0, react_1.useRef)(0);
    const [started, setStarted] = (0, react_1.useState)(false);
    const [duration, setDuration] = (0, react_1.useState)(0);
    const [current, setCurrent] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const audio = audioRef.current;
        if (!audio)
            return;
        const onTimeUpdate = () => {
            lastTimeRef.current = audio.currentTime;
            setCurrent(audio.currentTime);
        };
        const onLoadedMetadata = () => setDuration(audio.duration || 0);
        // 구간 이동(클릭/드래그/미디어키 등) 차단 — 정방향 연속 재생만 허용
        const onSeeking = () => {
            if (Math.abs(audio.currentTime - lastTimeRef.current) > 0.5) {
                audio.currentTime = lastTimeRef.current;
            }
        };
        audio.addEventListener('timeupdate', onTimeUpdate);
        audio.addEventListener('loadedmetadata', onLoadedMetadata);
        audio.addEventListener('seeking', onSeeking);
        return () => {
            audio.removeEventListener('timeupdate', onTimeUpdate);
            audio.removeEventListener('loadedmetadata', onLoadedMetadata);
            audio.removeEventListener('seeking', onSeeking);
        };
    }, []);
    const handlePlay = () => {
        const audio = audioRef.current;
        if (!audio || started)
            return; // 최초 1회만 재생, 이후 일시정지 불가
        setStarted(true);
        audio.play().catch(() => { });
    };
    const pct = duration > 0 ? Math.min(100, (current / duration) * 100) : 0;
    return (react_1.default.createElement(Wrap, null,
        react_1.default.createElement("audio", { ref: audioRef, src: src.replace(/\s/g, '%20'), preload: "metadata" }),
        react_1.default.createElement("button", { type: "button", className: "play-btn", onClick: handlePlay, disabled: started }, "\u25B6"),
        fileName && (react_1.default.createElement("span", { className: "name", title: fileName }, fileName)),
        react_1.default.createElement("div", { className: "bar" },
            react_1.default.createElement("div", { className: "fill", style: { width: `${pct}%` } })),
        react_1.default.createElement("span", { className: "time" },
            formatTime(current),
            " / ",
            formatTime(duration))));
};
exports.AudioPlayer = AudioPlayer;
